export default {
  methods: {
    languageUpdate () {
      const changeTranslate = (childs) => {
        for (let child of childs) {
          child.$forceUpdate()
          if (child.$children) {
            changeTranslate(child.$children)
          }
        }
      }
      this.$nextTick(() => {
        try {
          let childs = this.$router.app.$children[0].$children
          changeTranslate(childs)
        } catch (e) {
          console.log(e)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/LanguageMixin/LanguageMixin.js